import React from 'react';
import styled from 'styled-components';

const keyframes = require('styled-components').keyframes;

const Spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  min-height: calc(100vh - 448px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LoaderIndicator = styled.div`
  border: 7.5px solid #80807821;
  border-top: 7.5px solid #0055ab;
  border-radius: 50%;
  width: 75px;
  height: 75px;
  animation: ${Spin} 2s linear infinite;
`;
const LoaderInfo = styled.p`
  margin-top: 1rem;
  font-size: .925rem;
}
`;
interface LoaderProps {
  info?: string;
}

const Loader = ({ info }: LoaderProps) => (
  <Container>
    <LoaderIndicator className="loader-container__loader" />
    <LoaderInfo className="loader-container__loader-info">{info}</LoaderInfo>
  </Container>
);

export default Loader;
